import { StatsAdapterInterface } from '../../../stats/adapter.interface';
import { StatsContextInterface } from '../../../stats/context.interface';
import { GtmStatsDataEntityInterface } from '../data/entity.interface';
import { GtmStatsDataEcommerceProductClickInterface } from '../data/ecommerce-product-click.interface';

export class GtmStatsAdapterEcommerceProductClick implements StatsAdapterInterface {
  /**
   *
   * @param entity
   * @param context
   */
  constructor(protected entity: GtmStatsDataEntityInterface, protected context: StatsContextInterface) {}

  /**
   * @inheritDoc
   */
  public getData(): GtmStatsDataEcommerceProductClickInterface {
    if (!this.context.global.currency) {
      throw new Error('Stats global context "currency" is not set.');
    }

    return {
      ecommerce: {
        currencyCode: this.context.global.currency,
        click: {
          actionField: {
            action: 'click',
            list: this.entity.list,
          },
          products: [this.entity],
        },
      },
      event: 'productClick',
    };
  }
}
